import Button from '@mui/material/Button';
import Grid from '@mui/material/GridLegacy';
import Typography from '@mui/material/Typography';
import { useContext } from 'react';
import { useNavigate } from 'react-router';

import { BentleySystemsLogo } from '../../../assets/BentleySystemsLogo';
import { SeequentLogo } from '../../../assets/SeequentLogo';
import { LOGOUT_ROUTE } from '../../../constants';
import { isLoggedInWithBentleyToken } from '../../../store/sessionStorageHelpers/accessTokenHelper/accessTokenHelper';
import {
    INCORRECT_IDENTITY_PROVIDER_BENTLEY,
    INCORRECT_IDENTITY_PROVIDER_SEEQUENT,
    LOGOUT,
} from '../../../strings';
import type { LoginHandlerContextState } from '../../loginHandler/LoginContext';
import { LoginContext } from '../../loginHandler/LoginContext';
import { Background } from '../Background';
import { useStyles } from '../Background.styles';

export function CentralBackground({
    children,
    correctIdentityProvider = true,
}: React.PropsWithChildren<{
    correctIdentityProvider?: boolean;
}>) {
    const navigate = useNavigate();
    const { imageList } = useContext<LoginHandlerContextState>(LoginContext);
    const { classes } = useStyles({ imageList });
    const isLoggedInWithBentley = isLoggedInWithBentleyToken();

    return (
        <Background>
            {children}
            {!correctIdentityProvider && (
                <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    className={classes.signInBox}
                >
                    {isLoggedInWithBentley ? (
                        <SeequentLogo className={classes.logo} />
                    ) : (
                        <BentleySystemsLogo className={classes.logo} />
                    )}
                    <Typography className={classes.text}>
                        {isLoggedInWithBentley
                            ? INCORRECT_IDENTITY_PROVIDER_SEEQUENT
                            : INCORRECT_IDENTITY_PROVIDER_BENTLEY}
                    </Typography>
                    <Button variant="contained" size="large" onClick={() => navigate(LOGOUT_ROUTE)}>
                        {LOGOUT} of {isLoggedInWithBentley ? 'Bentley Account' : 'Seequent ID'}
                    </Button>
                </Grid>
            )}
        </Background>
    );
}
